
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Workflows from './components/Workflows';
import Benefits from './components/Benefits';
import Testimonial from './components/Testimonial';
import Demo from './components/Demo';
import Security from './components/Security';
import FinalCTA from './components/FinalCTA';
import Navbar from './components/Navbar';
import StickyDemo from './components/StickyDemo';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    // Función de scroll suave profesional
    const smoothScrollTo = (element: HTMLElement) => {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 30; // Offset reducido para aparecer más arriba
      
      // Scroll suave con comportamiento nativo optimizado
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    };

    // Verificar si hay state de navegación con scrollTo
    if (location.state && (location.state as any).scrollTo) {
      const sectionId = (location.state as any).scrollTo;
      
      // Esperar a que la página se cargue completamente con renderizado completo
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // Delay adicional para transición ultra suave
          requestAnimationFrame(() => {
            setTimeout(() => smoothScrollTo(element), 100);
          });
        }
      }, 600); // Timing extendido para suavidad máxima
      
      return () => clearTimeout(timeoutId);
    }
    
    // También manejar hash de la URL
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          requestAnimationFrame(() => {
            setTimeout(() => smoothScrollTo(element), 100);
          });
        }
      }, 600);
      
      return () => clearTimeout(timeoutId);
    }
  }, [location]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <Workflows />
      <Benefits />
      <Testimonial />
      <Demo />
      <Security />
      <FinalCTA />
      <StickyDemo />
    </div>
  );
}
